const yellow = [
    '0287484f-640d-4648-90d4-f0ec9e436c02'
]

export default yellow;